import React from 'react';
import AuthOktaCallback from './features/okta-callback/AuthOktaCallback';
import AuthLogout from './features/logout/AuthLogout';
import PAuthLoginCallback from './pages/PAuthLoginCallback';
import Auth from './Auth';
import PAuthInvestorUserActivationLanding from './pages/PAuthInvestorUserActivationLanding';

const AuthRoutes = {
	login: {
		tag: 'auth_login',
		path: '/login',
		auth: false,
		component: <Auth page="login" />,
	},
	login_callback: {
		tag: 'auth_login_callback',
		path: '/login/callback/:context',
		auth: false,
		component: <PAuthLoginCallback />,
	},
	logout: {
		tag: 'auth_logout',
		path: '/logout',
		auth: false,
		component: <AuthLogout />,
	},
	password_forgot: {
		tag: 'auth_password_forgot',
		path: '/auth/password-forgot',
		auth: false,
		component: <Auth page="password-forgot" />,
	},
	okta_callback: {
		tag: 'auth_okta_callback',
		path: '/callback',
		auth: false,
		component: <AuthOktaCallback />,
	},
	investor_reset_password: {
		tag: 'auth_investor_reset_password',
		path: '/auth/investor/reset-password/:recoveryToken',
		auth: false,
		component: <Auth page="investor-reset-password" />,
	},
	investor_user_activation: {
		tag: 'auth_investor_user_activation',
		path: '/auth/investor/user-activation/:activationToken',
		auth: false,
		component: <Auth page="investor-user-activation" />,
	},
	investor_user_activation_landing: {
		tag: 'auth_investor_user_activation_landing',
		path: '/auth/investor/user-activation',
		auth: false,
		component: <PAuthInvestorUserActivationLanding />,
	},
};

export default AuthRoutes;
